import { memo } from 'react';
import { formatAmount } from '@bonanza-social/moonlight';
import { Box, Text } from '@bonanza-social/moonlight';
import { PromoBadgeProps } from './PromoBadge.types';

function PromoBadge({ amount, children }: PromoBadgeProps) {
  return (
    <Box flexDirection="row" gap="space-100" alignItems="center">
      {children}
      <Text variant="body-m-semi" color="darkSurfacePrimary">
        {formatAmount(amount)}
      </Text>
    </Box>
  );
}

export default memo(PromoBadge);
